function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import logger from "./logger"; // Responsible for ensuring channel subscribe command is confirmed, retrying until confirmation is received.
// Internal class, not intended for direct user manipulation.

var SubscriptionGuarantor = /*#__PURE__*/function () {
  function SubscriptionGuarantor(subscriptions) {
    _classCallCheck(this, SubscriptionGuarantor);

    this.subscriptions = subscriptions;
    this.pendingSubscriptions = [];
  }

  _createClass(SubscriptionGuarantor, [{
    key: "guarantee",
    value: function guarantee(subscription) {
      if (this.pendingSubscriptions.indexOf(subscription) == -1) {
        logger.log("SubscriptionGuarantor guaranteeing ".concat(subscription.identifier));
        this.pendingSubscriptions.push(subscription);
      } else {
        logger.log("SubscriptionGuarantor already guaranteeing ".concat(subscription.identifier));
      }

      this.startGuaranteeing();
    }
  }, {
    key: "forget",
    value: function forget(subscription) {
      logger.log("SubscriptionGuarantor forgetting ".concat(subscription.identifier));
      this.pendingSubscriptions = this.pendingSubscriptions.filter(function (s) {
        return s !== subscription;
      });
    }
  }, {
    key: "startGuaranteeing",
    value: function startGuaranteeing() {
      this.stopGuaranteeing();
      this.retrySubscribing();
    }
  }, {
    key: "stopGuaranteeing",
    value: function stopGuaranteeing() {
      clearTimeout(this.retryTimeout);
    }
  }, {
    key: "retrySubscribing",
    value: function retrySubscribing() {
      var _this = this;

      this.retryTimeout = setTimeout(function () {
        if (_this.subscriptions && typeof _this.subscriptions.subscribe === "function") {
          _this.pendingSubscriptions.map(function (subscription) {
            logger.log("SubscriptionGuarantor resubscribing ".concat(subscription.identifier));

            _this.subscriptions.subscribe(subscription);
          });
        }
      }, 500);
    }
  }]);

  return SubscriptionGuarantor;
}();

export default SubscriptionGuarantor;